// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"9bdf8562","189":"1edcd333","416":"05e597cd","811":"a71d683f"}[chunkId] + ".chunk.js";
};